<template>
    <div style="background-color: white">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row dense>
            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
                <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>
        </v-row>
        <div v-if="istemplateApplicable === true">
            <span v-html="rawhtmlcode"></span>
        </div>
       <div v-else-if="istemplateApplicable === false" class="row" style="justify-content:center">
            <span class="grey--text">
                DOCUMENT TEMPLATE OR LINKING IS MISSING...
            </span>
        </div>
       <v-overlay :value="overlay">
            <div style="text-align:center">
                <v-progress-circular indeterminate size="64"></v-progress-circular>

                <div style="margin-top: 15px; font-size:18px;">
                    Generating {{ progressCount }}
                </div>
            </div>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                name: null,
                dob: null,
                roll_no: null,
                mobile_no: null,
                address: null,
                mother_name: null,
                photo: null,
                reg_no: null,
                gr_no: null,
                father_full_name: null,
                leraner_marksheet: [],
                semester: null,
                colspan: null,
                overall_grade: null,
                remark: [],
                org_basic_data: null,
                istemplateApplicable: null,
                std:null,
                div:null,
                status:'',
                progressCount: 0,
                totalCount: 0,
                progressTimer: null,
                aboutMe: [
                    { label: "MY NAME IS" },
                    { label: "I STUDY IN" },
                    { label: "THINGS I LIKE" },
                    { label: "I LIVE IN" },
                    { label: "MY BIRTHDAY" },
                    { label: "MY FRIENDS ARE" },
                ],
                favourites: [{ label: "COLOURS" }, { label: "FOODS" }, { label: "GAMES" }, { label: "ANIMALS" }],

                reportingDate: "/ / 202 ",

                activities: [
                    "1. Activity / Activities I enjoyed the most which included Story telling, Music, Dance, Puppetry, Games, Art & Craft",
                    "2. Activities that I found difficult to (will be filled by the teacher through continuous observation & interaction.",
                    "3. To do this activity I need the support of peer / Teacher / Books / Computer",
                ],
                peerRows: [
                    "Help in completing task/Activity",
                    "Likes to play with others",
                    "Shares stationery with classmate",
                ],

                parent_observations: [
                    "MY CHILD:",
                    "Finds the classroom and school to be a welcoming space",
                    "Finds the classroom and school to be a safe space",
                    "Respects everyone's opinions.",
                    "Participates in different activities in the school",
                    "Is making good progress as per their grade",
                    "Is getting the support needed from school",
                    "Can help his/her friends make up after a fight",
                ],
                selfRows: [
                    {
                        text: "1. Activity / Activities I enjoyed the most which included Story telling, Music, Dance, Puppetry, Games, Art & Craft",
                    },
                    {
                        text: "2. Activities that I found difficult to (will be filled by the teacher through continuous observation & interaction.",
                    },
                    { text: "3. To do this activity I need the support of peer / Teacher / Books / Computer" },
                ],

                observations: [
                    "My friend can talk about how he/she feels, e.g. happy, confident, upset or angry.",
                    "My friend can calm himself/herself down during difficult situations.",
                    "My friend can understand how his/her friends feel.",
                    "My friend respects everyone's opinions.",
                    "My friend can help others make up after a fight.",
                    "When someone is sad, my friend can make them feel better.",
                ],

                leftSupport: ["Oral communication", "Reading", "Mathematics", "Self-Confidence"],

                rightSupport: ["Working with other children", "Working independently at home"],
            };
        },
        computed: {
            trustFirst() {
                if (!this.org_basic_data.school_name) return "";
                return this.org_basic_data.school_name.split(" ")[0];
            },
            trustRest() {
                if (!this.org_basic_data.school_name) return "";
                return this.org_basic_data.school_name.split(" ").slice(1).join(" ");
            },
        },

        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const data = {
                    lid: this.registration_no,
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    org: this.org,
                };
                axios
                    .post("/Examination/getAnnualStudentReportTemplate", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.div = res.data.div;
                            this.ay = res.data.ay;
                            this.name = res.data.name;
                            this.dob = res.data.dob;
                            this.roll_no = res.data.roll_no;
                            this.mobile_no = res.data.mobile_no;
                            this.address = res.data.address;
                            this.mother_name = res.data.mother_name;
                            this.photo = res.data.photo;
                            this.reg_no = res.data.reg_no;
                            this.gr_no = res.data.gr_no;
                            this.father_full_name = res.data.father_full_name;
                            this.leraner_marksheet = res.data.leraner_marksheet;
                            // console.log(this.leraner_marksheet)
                            this.semester = res.data.semester;
                            this.default_value = res.data.default_value;
                            this.org_basic_data = res.data.org_basic_data;
                            this.mother_contact = res.data.mother_contact;
                            this.father_contact = res.data.father_contact;
                            this.overlay = false;
                            this.rawhtmlcode = res.data.output;
                            this.istemplateApplicable = res.data.istemplateApplicable;
                        }
                        else {
                            this.istemplateApplicable = false;
                            this.showSnackbar("#b71c1c", res.data.smsg);
                        }
                    })
                    .catch(() => {
                        this.istemplateApplicable = false;
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            handleBulk() {
                this.overlay = true;

                const payload = {
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    standard: this.std,
                    division: this.div,
                    org: this.org,
                    viewType: this.viewType,
                    status: this.status,
                };

                this.startFakeProgress();

                axios.post("/Examination/getAnnualStudentReportTemplateBulk", payload)
                    .then((res) => {

                        if (res.data.flag === "YES") {
                            clearInterval(this.progressTimer);
                            const realTotal = res.data.totalCount || this.totalCount;
                            this.totalCount = realTotal;
                            this.progressCount = Math.min(this.progressCount, realTotal);
                            this.progressCount = realTotal;
                            this.rawhtmlcode = res.data.output;
                            this.istemplateApplicable = res.data.istemplateApplicable;
                            this.overlay = false;
                        } else {
                            this.istemplateApplicable = false;
                        }
                    })
                    .catch(() => {
                        this.istemplateApplicable = false;
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        clearInterval(this.progressTimer);
                        this.overlay = false;
                    });
            },
            startFakeProgress() {
                this.progressCount = 0;

                this.totalCount = 50; // fake max

                this.progressTimer = setInterval(() => {

                    const limit = Math.floor(this.totalCount * 0.9);

                    if (this.progressCount < limit) {
                        this.progressCount++;
                    }

                }, 300);
            }
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.sem = localStorage.getItem("setsem");
            this.registration_no = localStorage.getItem("setreg_no");
            this.std = localStorage.getItem("setstd");
            console.log(this.std);
            this.div = localStorage.getItem("setdiv");
            this.org = localStorage.getItem("EPS-org-id");
            this.status = localStorage.getItem("status");
            const isBulk = localStorage.getItem("isBulk");
            if (isBulk === "true") {
                this.handleBulk();
            } else {
                this.registration_no = localStorage.getItem("setreg_no");
                this.onload();
            }
        },
    };
</script>
